import "../../new.scss";
import { useState, useEffect, useCallback } from "react";
import { DescuentosFormContext } from '../../../context/descuentos/DescuentosContext';
import { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import { formatDate } from "../../../helpers/dateUtils";

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { postDescuentoData, report, patchDescuentoData } = useContext(DescuentosFormContext);
  // ID de edicion 
  const { id } = useParams();
  // Navigate to datagrid
  const navigate = useNavigate();
  // Manejo de errors
  const [errors, setErrors] = useState({})
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const formatDateMemoized = useCallback(formatDate, []);
  const nameData = "descuentos";
  const saveData = postDescuentoData;
  const updateData = patchDescuentoData;
  const formatToLocalDatetime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const pad = (n) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm({
        ...report,
        desc_fecha_inicio: report.desc_fecha_inicio ? formatToLocalDatetime(report.desc_fecha_inicio) : "",
        desc_fecha_fin: report.desc_fecha_fin ? formatToLocalDatetime(report.desc_fecha_fin) : "",
      });
    }
  }, [report]);


  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs(id), setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs(id).forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  // Mostrar diálogos
  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs(id).reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      // Crear una copia del form para no mutar el original
      const preparedForm = { ...form };

      // Función para formatear fecha en hora local a "YYYY-MM-DD HH:mm:ss"
      const formatLocalDateToSQL = (date) => {
        const pad = (n) => (n < 10 ? "0" + n : n);
        return (
          date.getFullYear() +
          "-" +
          pad(date.getMonth() + 1) +
          "-" +
          pad(date.getDate()) +
          " " +
          pad(date.getHours()) +
          ":" +
          pad(date.getMinutes()) +
          ":" +
          pad(date.getSeconds())
        );
      };

      // Convertir desc_fecha_inicio y desc_fecha_fin
      if (preparedForm.desc_fecha_inicio) {
        const startDate = new Date(preparedForm.desc_fecha_inicio);
        preparedForm.desc_fecha_inicio = formatLocalDateToSQL(startDate);
      }

      if (preparedForm.desc_fecha_fin) {
        const endDate = new Date(preparedForm.desc_fecha_fin);
        preparedForm.desc_fecha_fin = formatLocalDateToSQL(endDate);
      }


      // Llamada al backend
      if (id) {
        await updateData(id, preparedForm);
      } else {
        await saveData(preparedForm);
      }

      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };



  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs(id).map((input) => (
                <FormField
                  key={input.id}
                  fieldKey={input.id}
                  input={input}
                  value={form[input.name]}
                  handleInputChange={handleChange}
                  error={errors[input.name]}
                />
              ))}
 </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            {/* Diálogos */}
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
